import { PropsWithChildren } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const Desktop = ({ children }: PropsWithChildren) => {
  const { isMobile } = useResponsiveDesign()

  if (isMobile) {
    return null
  }

  return <>{children}</>
}
